import React, { useState } from 'react';
import { Wrapper, Title } from './Accordion.styles';
import AccordionCard from '../AccordionCard/AccordionCard';

const Accordion = ({ mainTitle, items }) => {
  const [activeId, setActiveId] = useState(false);
  const handleChange = id => {
    setActiveId(id === activeId ? false : id);
  };
  return (
    <>
      <Title>{mainTitle}</Title>
      <Wrapper>
        {items.map((item, index) => (
          <AccordionCard
            title={item.title}
            text={item.text}
            onChange={handleChange}
            isActive={activeId === index}
            key={index}
            index={index}
          />
        ))}
      </Wrapper>
    </>
  );
};

export default Accordion;
